module.exports = __webpack_public_path__ + "images/check-black-853944dd.svg";